import React, { useEffect, useState } from "react";
import { Box, Typography, Button, Grid } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";
import EditIcon from "@mui/icons-material/Edit";
import { fetchSuccessFactor } from "../../api/companyApi";
import { useNotification } from "../../providers/NotificationProvider";
import DetailSection from "../../components/common/DetailSection";
import DetailField from "../../components/common/DetailField";

export default function InfoCapitalIssueDataDetailPage() {
  const { businessDomainId, successFactorId } = useParams();
  const navigate = useNavigate();
  const intl = useIntl();
  const notify = useNotification();
  const t = (id) => intl.formatMessage({ id });
  const [data, setData] = useState(null);
  useEffect(() => {
    (async () => { try { setData(await fetchSuccessFactor(successFactorId)); } catch (e) { notify.apiError(e); } })();
  }, [successFactorId]);
  if (!data) return null;
  return (
    <Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
        <Typography variant="h6">{t("infoCapitalIssueData.detail.title")}</Typography>
        <Button variant="contained" startIcon={<EditIcon />} onClick={() => navigate(`/strategy/${businessDomainId}/info-capital-issues-data/${successFactorId}/edit`)}>{t("common.edit")}</Button>
      </Box>
      <DetailSection>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}><DetailField label={t("successFactor.name")} value={data.successFactorName} /></Grid>
          <Grid item xs={12}><DetailField label={t("common.description")} value={data.successFactorDescription} /></Grid>
          <Grid item xs={12} md={6}><DetailField label={t("businessDomain.name")} value={data.businessDomainName} /></Grid>
        </Grid>
      </DetailSection>
      <Button variant="outlined" onClick={() => navigate(`/strategy/${businessDomainId}/info-capital-issues-data`)}>{t("common.back")}</Button>
    </Box>
  );
}
